import { render } from "./PostInfoComponent.vue?vue&type=template&id=b3f3c688"
import script from "./PostInfoComponent.vue?vue&type=script&lang=js"
export * from "./PostInfoComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__